module.exports = __webpack_public_path__ + "static/media/user_logo.713a1b08.svg";